export function initInScope ($scope) {
    $scope.find('.js-collapse-open').on('click', function (e) {
        e.preventDefault();
        let selector = $(this).data('target') || $(this).attr('href');
        if (selector) {
            let $target = $(selector);

            if ($target && $target.length) {
                $target.collapse('show');
            }
        }
    });


    /* wird benötigt für hoteldetail anfrage-collapse aus translation-key */
    $scope.find('.js-scroll-n-collapse').on('click', function (e) {
        e.preventDefault();
        let selector = $(this).attr('href');
        if (selector) {
            let $target = $(selector);

            if ($target && $target.length) {
                $target.collapse('show');
            }
            window.scrollTo(0, $target.offset().top - 180);
        }
    });
}
